import styled, { css, CSSProperties } from 'styled-components'
import { isDesktop } from '../../../../lib/screenHelpers'
import primitives from '@veneer/primitives'

export const HpxCard = styled.div<{
  $padding: string
  $splitCard?: boolean
  $step?: string
  $isHpxVPDesign?: boolean
  $customProps?: CSSProperties
}>`
  && {
    ${({
      theme: { isHpx, containerSize },
      $padding,
      $splitCard,
      $step,
      $isHpxVPDesign
    }) => {
      if (isHpx) {
        return css`
          overflow: hidden;
          background-color: ${primitives.color.white};
          border-radius: 24px;
          padding: ${$padding};
          position: relative;
          z-index: 1;

          ${$step === 'connect' &&
          css`
            @media (max-width: 1440px) {
              padding: 16px;
            }
          `}

          ${!isDesktop(containerSize) &&
          !$splitCard &&
          $step !== 'connect' &&
          css`
            padding: ${$isHpxVPDesign ? '24px' : '16px'};
          `}
        `
      }
    }}
    ${({ $customProps }) =>
      $customProps &&
      Object.entries($customProps).map(
        ([key, value]) =>
          `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}: ${value};`
      )}
  }
`

export const ContentContainer = styled.div<{ $useMediaQuery?: boolean }>`
  && {
    display: flex;
    align-items: stretch;

    ${({ $useMediaQuery }) =>
      $useMediaQuery
        ? css`
            @media (max-width: 1440px) {
              flex-direction: column;
            }
          `
        : css`
            ${({ theme: { containerSize } }) =>
              !isDesktop(containerSize) &&
              css`
                flex-direction: column;
              `}
          `}
  }
`

export const LeftSection = styled.div`
  && {
    display: flex;
    width: 50%;
    min-width: 40%;
    background-color: #f5f6ff;
    justify-content: center;
    align-items: center;

    ${({ theme: { containerSize } }) =>
      !isDesktop(containerSize) &&
      css`
        width: 100%;
        padding-top: 32px;
      `};
  }
`

export const RightSection = styled.div`
  && {
    display: flex;
    flex-direction: column;
    flex: 1;
    box-sizing: border-box;
    padding: 32px;

    ${({ theme: { containerSize } }) =>
      !isDesktop(containerSize) &&
      css`
        width: 100%;
        padding: 32px 16px;
      `};
  }
`
